import React from 'react'
import Navbar from '../components/header/navbar'
import PrivacyComp from '../components/Privacy/privacy'

const Privacy = () => {
  return (
    <div className='max-w-7xl mx-auto'>
      <Navbar />
      <PrivacyComp />
    </div>
  )
}

export default Privacy
